// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__i8jYO"};